import {useConfig} from "./useConfig";
import {useCallback} from "react";

export function useRedirectToMySGI() {
  const config = useConfig();
  return useCallback(() => window.location.assign(config.MYSGI_URL), [config]);
}
